import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@/lib/icons";
import AppHeader from "@/components/AppHeader";
import SoundToggle from "./SoundToggle";
import Main from "@/components/Main";

/**
 * Page chrome shared by every game: AppHeader, breadcrumb back to /play,
 * title, optional subtitle, and a constrained content column.
 */
export default function GameLayout({
  title,
  subtitle,
  headerActions,
  children,
}: {
  title: string;
  subtitle?: string;
  /**
   * Optional inline actions rendered just below the subtitle. Typically
   * a `<GameMenu />` providing How-to-play and Reset controls.
   */
  headerActions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-transparent">
      <AppHeader />
      <Main className="max-w-[900px] mx-auto px-4 py-6">
        <Link
          to="/play"
          className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground mb-4 transition-colors"
        >
          <ArrowLeft size={12} aria-hidden="true" />
          Back to Play
        </Link>
        <header className="mb-5 flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h1 className="text-2xl font-bold text-foreground mb-1">{title}</h1>
            {subtitle && (
              <p className="text-sm text-muted-foreground">{subtitle}</p>
            )}
            {headerActions && <div className="mt-2">{headerActions}</div>}
          </div>
          <SoundToggle className="flex-shrink-0 mt-1" />
        </header>
        {children}
      </Main>
    </div>
  );
}